import { IApplicationState } from '../../types/redux';
import { formatPhone } from '../../utils/formatters/phone';

export const selectBuilderPhone = (state: IApplicationState) => {
  const { phone } = state.projectData.builder;

  if (!phone) {
    return undefined;
  }

  return formatPhone(phone);
};
